const key = 'resources'
export default key
